<template>
  <div class="content">
    <div class="manage">
      <!-- <NovoImg width="100%" :src="manageImg" :isLazy="true"/> -->
      <img :src="manageImg" alt="云端管理平台">
      <span :class="{manageTitle: true}">云端管理平台</span>
    </div>
    <!-- 云端管理平台 -->
    <div class="manageContent">
      <div :class="{upWrap: true, goUp: homeContentA1}" id="homeContentA1">
        <div class="manageWrap width1060">
          <div class="manageItem">
            <h4 class="mTitle hasBottomLine">人员卡片管理</h4>
            <div
              class="mContent"
            >人员卡片管理的主要功能是实现用户和卡片的集中管理。它不仅可以提供灵活的用户分类，解决组织机构的多级管理问题，还可以实现多级门禁的级联管理。</div>
          </div>
          <div class="manageItem">
            <h4 class="mTitle hasBottomLine">设备管理</h4>
            <div
              class="mContent"
            >设备管理是指对空间内不同区域的不同设备进行管理。可以实现设备的基本信息编辑、状态实时查询、自动化远程升级和节假日定制界面推送等功能。</div>
          </div>
          <div class="manageItem">
            <h4 class="mTitle hasBottomLine">会议室预订管理</h4>
            <div
              class="mContent"
            >会议室预订管理通过设备与会议室关联的方式，实现会议室状态实时查询。该功能不仅支持会议室的新增，修改，删除，还支持会议室的预订、取消、续约，可满足用户多种预订需求。</div>
          </div>
        </div>
        <div class="checkOpen">
          <router-link to="/open_platform">查看开放平台</router-link>
        </div>
      </div>
      <div class="line"></div>
      <!-- 硬件参数 -->
      <div class="device">
        <div v-show="!isVideo" class="img-transfrom">
          <img
            style="height: 635px;margin-top: -3px;"
            ref="transformImg"
            :src="require('common/image/home/customer/machine.png')"
            alt=""
          >
        </div>
        <div v-show="isVideo"  class="video-box">
          <!-- <img ref="amimationImg" src="" alt=""> -->
          <NovoVideo
            class="video"
            :stop="!isVideo"
            src="/static/video/tranfrom.mp4"
            poster="require('common/image/home/customer/machine.png')"
          />
        </div>
        <span class="checkParam" @click="open">查看硬件参数</span>
        <div :class="{ modal: true, modalOpen: openModal, modalClose: closeModal}">
          <div class="width1060">
            <div :class="{close: true}" @click="close">收起</div>
            <div :class="{params: true}">
              <div class="line"></div>
              <div class="paramItem" v-for="(i,index) in paramItems" :key="index">
                <div>
                  <span class="paramTitle">{{i.desc}}</span>
                  <span>{{i.val}}</span>
                </div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onceScollHandle } from "common/js/utils";
import Bus from "store/bus.js";
import { NovoGotop, LazyLoading, NovoVideo, NovoImg } from "novo-ui";

export default {
  name: "Home",
  components: {
    NovoGotop,
    NovoVideo,
    NovoImg
  },
  data() {
    return {
      load: false,
      isVideo: true,
      manageImg: require("common/image/home/manage.png"),
      kr: require("common/image/home/customer/36kr.png"),
      novoiot: require("common/image/home/customer/novoiot.png"),
      krspace: require("common/image/home/customer/krspace.png"),
      footImg: require("common/image/home/footImg.png"),
      footImg2: require("common/image/home/footImg2.png"),
      deviceImg: require("common/image/home/device.png"),
      mySwiper: {},
      swiperOption: {
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        speed: 30,
        simulateTouch: false,
        effect: "cube",
        autoplay: {
          delay: 0,
          autoplayDisableOnInteraction: false
        },
        fadeEffect: {
          crossFade: true
        },
        cubeEffect: {
          slideShadows: false,
          shadow: false
        },
        loop: true
      },
      photos: Array(36).fill(0),
      openModal: false,
      closeModal: false,
      imgHover: false,
      paramItems: [
        {
          desc: "电压输入",
          val: "DC5V-5.75V"
        },
        {
          desc: "工作电流",
          val: "600mA"
        },
        {
          desc: "电源接口",
          val: "DC039A"
        },
        {
          desc: "通讯方式",
          val: "TCP/IP"
        },
        {
          desc: "网络接口",
          val: "RJ45"
        },
        {
          desc: "网口速率",
          val: "10/100Mbps"
        },
        {
          desc: "刷卡频率",
          val: "13.56MHz"
        },
        {
          desc: "处理器",
          val: "Allwinner A33"
        },
        {
          desc: "存储器",
          val: "DDR：DDR3 512MB；EMMC：4GB"
        },
        {
          desc: "触摸屏尺寸",
          val: "5.0英寸"
        },
        {
          desc: "屏幕分辨率",
          val: "800 * 480dpi"
        },
        {
          desc: "产品型号",
          val: "KAC-100"
        },
        {
          desc: "工作温度",
          val: "0-55°C"
        },
        {
          desc: "通讯协议",
          val: "TCP/IP"
        },
        {
          desc: "执行标准",
          val: "GA/T394-2002《出入口控制系统技术要求》"
        },
        {
          desc: "整体尺寸",
          val: "长 231.65mm * 宽 104.10mm * 高 44.05mm"
        },
        {
          desc: "系统平台",
          val: "Android"
        },
        {
          desc: "联网方式",
          val: "WIFI、RJ45网口"
        },
        {
          desc: "嵌墙尺寸",
          val: "长 183.65mm * 宽 84.5mm * 高 21.8mm"
        }
      ],
      homeContentA1: false,
      homeContentA2: false
    };
  },
  mounted() {
    this.load = true;
    onceScollHandle(document.getElementById("homeContentA1"), () => {
      this.homeContentA1 = true;
    });
    onceScollHandle(document.getElementById("homeContentA2"), () => {
      this.homeContentA2 = true;
    });
    // this.$refs['transformImg'].src = require('common/image/home/0_18-min.png');
    // this.transformImg(this.$refs['amimationImg'],0)
  },
  methods: {
    transformImg(dom, i) {
      dom.src = animationArr[i];
      i += 2;
      if (i > 181) {
        i = 1;
      }
      setTimeout(() => {
        this.transformImg(dom, i);
      }, 60);
    },
    open() {
      this.isVideo = false;
      this.$refs["transformImg"].className = "rightToLeft";
      setTimeout(() => {
        this.openModal = true;
        this.closeModal = false;
      }, 500);
    },
    close() {
      this.closeModal = true;
      this.openModal = false;
      setTimeout(() => {
        this.$refs["transformImg"].className = "leftToright";
      }, 500);

      setTimeout(() => {
        this.isVideo = true;
      }, 1500);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
@import "~common/scss/animation";
.content {
  .manage {
    position: relative;
    img {
      width: 100%;
    }
    .manageTitle {
      position: absolute;
      left: 29px;
      top: 29px;
      font-size: 24px;
      color: #000000;
      font-weight: 500;
      font-family: DFPKingGothicGB-Medium;
    }
  }
  .video-box,
  .img-transfrom {
    position: absolute;
    width: 220px;
    height: 490px;
    top: 50%;
    overflow: hidden;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 11;
    pointer-events: none;
    .video,
    img {
      position: absolute;
      /* height: 490px; */
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      top: 250px;
    }
  }
  .img-transfrom {
    overflow: visible;
  }
  .manageContent {
    .upWrap {
      // visibility: hidden;
    }
    .width1060 {
      &.manageWrap {
        display: flex;
        justify-content: space-between;
        .manageItem {
          width: 328px;
          text-align: center;
          color: #000000;
          .mTitle {
            font-size: 24px;
            margin: 26px 0 34px;
            height: 30px;
            line-height: 30px;
          }
          .mContent {
            font-size: 18px;
            line-height: 36px;
          }
        }
      }
      &.example {
        text-align: center;
        .exampleHead {
          margin: 60px 0;
          height: 29px;
          line-height: 29px;
          font-size: 24px;
          color: #707070;
          text-align: center;
        }
        .exampleContent {
          display: flex;
          justify-content: center;
          visibility: hidden;
          .item {
            width: 280px;
            margin: 0 40px;

            .img-box {
              width: 280px;
              height: 180px;
              border: 1px solid #3ca9ff;
              display: inline-block;
              // border-image: -webkit-linear-gradient(#7CE1FF, #3CA9FF) 30 30;
              // border-image: -moz-linear-gradient(#7CE1FF, #3CA9FF) 30 30;
              // border-image: -o-linear-gradient(#7CE1FF, #3CA9FF) 30 30;
              // border-image: linear-gradient(#7CE1FF, #3CA9FF) 30 30;
              position: relative;
              border-radius: 6px;
            }
            .itemImg {
              width: 175px;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translateX(-50%) translateY(-50%);
            }
            .mTitle {
              height: 30px;
              line-height: 30px;
              margin: 60px 0 34px;
              font-size: 24px;
            }
            .mContent {
              font-size: 18px;
              line-height: 36px;
            }
          }
        }
      }
    }
    .checkOpen {
      cursor: pointer;
      margin: 20px auto 50px auto;
      width: 180px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background-image: linear-gradient(-135deg, #4b9df0 0%, #7ce1ff 100%);
      border-radius: 22px;
      font-size: 18px;
      color: #ffffff;
      a {
        color: #fff;
      }
    }
  }
  .line {
    height: 1px;
    background-image: linear-gradient(-135deg, #4b9df0 0%, #5fcfff 100%);
    border-radius: 2px;
  }
  .hasBottomLine {
    position: relative;
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 40px;
      left: 45%;
      width: 30px;
      height: 8px;
      background-image: linear-gradient(-135deg, #3ca9ff 0%, #7ce1ff 100%);
      border-radius: 4px;
    }
  }
  .swiper-container {
    position: relative;
    top: 50px;
    width: 800px;
    /*height: 300px;*/
    .swiper-slide {
      /*background: green;*/
      /*height: 220px;*/
      img {
        width: 100%;
      }
    }
  }
  .device {
    position: relative;
    height: 710px;
    .checkParam {
      position: absolute;
      left: 65%;
      top: 48%;
      text-align: center;
      width: 180px;
      height: 44px;
      line-height: 44px;
      border: 1px solid #5fcfff;
      border-radius: 22px;
      font-size: 18px;
      color: #3ca9ff;
      cursor: pointer;
      z-index: 10;
    }
    .modal {
      overflow: hidden;
      background: #000;
      position: absolute;
      z-index: 10;
      top: 50%;
      bottom: 50%;
      left: 0;
      right: 0;
    }
    .modalOpen {
      -moz-animation: openAnimation 1s ease-in-out; /* Firefox */
      -webkit-animation: openAnimation 1s ease-in-out; /* Safari 和 Chrome */
      -o-animation: openAnimation 1s ease-in-out; /* Opera */
      animation: openAnimation 1s ease-in-out;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .modalClose {
      -moz-animation: closeAnimation 1s ease-in-out; /* Firefox */
      -webkit-animation: closeAnimation 1s ease-in-out; /* Safari 和 Chrome */
      -o-animation: closeAnimation 1s ease-in-out; /* Opera */
      animation: closeAnimation 1s ease-in-out;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .rightToLeft {
      -moz-animation: rightToLeft 1s ease-in-out; /* Firefox */
      -webkit-animation: rightToLeft 1s ease-in-out; /* Safari 和 Chrome */
      -o-animation: rightToLeft 1s ease-in-out; /* Opera */
      animation: rightToLeft 1s ease-in-out;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .leftToright {
      -moz-animation: leftToright 1s ease-in-out; /* Firefox */
      -webkit-animation: leftToright 1s ease-in-out; /* Safari 和 Chrome */
      -o-animation: leftToright 1s ease-in-out; /* Opera */
      animation: leftToright 1s ease-in-out;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    @keyframes openAnimation {
      0% {
        background: #534c57;
        top: 50%;
        bottom: 50%;
      }
      100% {
        background: #000;
        top: 0;
        bottom: 0;
      }
    }
    @keyframes closeAnimation {
      0% {
        background: #000;
        top: 0;
        bottom: 0;
      }
      100% {
        background: #534c57;
        top: 50%;
        bottom: 50%;
      }
    }
    @keyframes rightToLeft {
      0% {
        transform: translateX(-50%) translateY(-50%);
      }
      100% {
        transform: translateX(-63%) translateY(-50%);
      }
    }
    @keyframes leftToright {
      0% {
        transform: translateX(-63%) translateY(-50%);
      }
      100% {
        transform: translateX(-50%) translateY(-50%);
      }
    }

    .modal {
      color: #dcdcdc;
      .width1060 {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .close {
          position: relative;
          height: 44px;
          line-height: 44px;
          width: 93px;
          text-align: center;
          background-image: linear-gradient(-135deg, #7ce1ff 0%, #3ca9ff 100%);
          border-radius: 22px;
          font-size: 18px;
          color: #ffffff;
          cursor: pointer;
        }
        .deviceImg {
          position: relative;
          width: 220px;
        }
        .params {
          position: relative;
          width: 380px;
          margin-top: 5px;
          .paramItem {
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            .paramTitle {
              padding-left: 25px;
              display: inline-block;
              width: 90px;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/content/index.vue